"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDebug = void 0;
const debug_1 = __importDefault(require("debug"));
/**
 * Tworzy instancję debugera
 *
 * @export
 * @param {string} namespace
 * @returns {debug.Debugger}
 */
function createDebug(namespace) {
    return (0, debug_1.default)('witkac:' + namespace);
}
exports.createDebug = createDebug;
//# sourceMappingURL=createDebug.js.map